import React, { useState, useEffect, useContext } from 'react'
import { useParams, Redirect } from 'react-router-dom'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { Message } from 'primereact/message'
import { ProgramService } from '../../services/Program'
import { ProgramForm } from '../../components/ProgramForm'
import { Layout } from '../../components/Layout'
import './styles.scss'

export const CreateEditPrograms = () => {
  const { id: idToEdit } = useParams()
  const { isAuth: token } = useContext(Context)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [redirectTo, setRedirectTo] = useState(null)
  const [programToEdit, setProgramToEdit] = useState([])
  const [courseList, setCourseList] = useState([])
  const [courseListToEdit, seCourseListToEdit] = useState([])

  const config = {
    title: 'Crear Programa',
    icon: GLOBALS.menu.programs.icon,
    link: GLOBALS.menu.programs.link,
    linkList: GLOBALS.menu.programs.linkList,
  }

  if (idToEdit) {
    config.title = 'Editar Programa'
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const [programs, courseList, courseListToEdit] = await Promise.all([
        (async () => {
          if (idToEdit) {
            return await ProgramService.getById(idToEdit, token)
          }
          return null
        })(),
        ProgramService.getProgramxEmptyCourse(token),
        (async () => {
          if (idToEdit) {
            return await ProgramService.getById(idToEdit, token) 
          }
          return null
        })(),
      ])

      setProgramToEdit(programs)

      setCourseList(
        courseList.map((u) => {
          return {
            label: `${u.name}`,
            value: u.id,
          }
        }))

      if (idToEdit) {
        if (courseListToEdit) {
          seCourseListToEdit(
            courseListToEdit.courses.map((u) => {
              return {
                label: `${u.name}`,
                value: u.id,
              }
            }))
        }
      }

    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      if (idToEdit) {
        await ProgramService.update(idToEdit, data, token)
      } else {
        await ProgramService.create(data, token);
      }

      setIsLoading(false)
      setError(null)

      setRedirectTo({
        pathname: config.linkList,
        state: { success: true },
      })
    } catch (e) {
      setIsLoading(false)
      setError(e.message)
    }
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  return (
    <Layout>
      {isLoading ? (
          <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : error ? (
        <Message severity="error" text={error}></Message>
      ) : (
        <div className="p-fluid">
          <div className="p-grid">
            <div className="p-col-12">
              <div className="card card-w-title">
                <h1 className="create-edit-title">
                  {config.icon && <i className={config.icon}></i>}
                  {config.title}
                </h1>

                <ProgramForm
                  item={programToEdit}
                  courseListToEdit={courseListToEdit}
                  courseList={courseList}
                  isLoading={isLoading}
                  onSubmit={onSubmit}
                  cancelLink={config.linkList}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
